import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { PaymentService } from '../../models/paymentService';
import { PreProcurementService } from 'src/app/services/pre-procurement.service';
import { CatUploadService } from 'src/app/services/cat-upload.service';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { CatEditService } from 'src/app/services/cat-edit.service';
import { ESignService } from 'src/app/services/e-sign.service';
import { EstampService } from 'src/app/services/estamp.service';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ConfirmationService, ConfirmEventType } from 'primeng/api';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { StorageService } from 'src/app/services/storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { OrderService } from 'src/app/services/order.service';
import { forkJoin } from 'rxjs';
import { WalletService } from 'src/app/services/wallet.service';
import { TableColumn } from '../data-table/data-table.component';

@Component({
    selector: 'app-payment-order',
    templateUrl: './payment-order.component.html',
    styleUrls: ['./payment-order.component.scss'],
    standalone: false
})
export class PaymentOrderComponent implements OnInit, OnDestroy {
  @ViewChild('reviewOrder') reviewOrder: TemplateRef<any>;
  @ViewChild('paymentModal') paymentModal: TemplateRef<any>;
  @ViewChild('walletPaymentSuccessModal')
  walletPaymentSuccessModal: TemplateRef<any>;
  @ViewChild('confirmOrderModal') confirmOrderModal: TemplateRef<any>;
  
  @Input() paymentOrderData: any = {};
  @Input() reOrderData: any;
  @Output() paymentOrderDataChange: EventEmitter<any> = new EventEmitter<[]>();
  @Output() paymentOrderDetails: EventEmitter<any> = new EventEmitter<[]>();
  insufficientInventory: boolean = false;
  paymentData: PaymentService;
  paymentDetails: {
    payeeName: string;
    payeeEmail: string;
    payeeMobileNumber: string;
    payNow: string;
    paymentMethod: string;
  };
  signDetails: any = [];
  electronicSigner: any = [];
  aadhaarSigner: any = [];
  dscSigner: any = [];
  cloudSigner: any = [];
  electronicPrice: number;
  dscPrice: number;
  aadhaarPrice: number;
  cloudPrice: number;
  cloudSerialNo: number;
  stampPrice: number;
  stampDetails: any = [];
  stampAmountTotal: any = 0;
  signAmountTotal: any = 0;
  walletBalance: any;
  canWalletPayment: boolean = true;
  usedCurrency: string;
  articles: any = [];
  stateCode: any;
  catPaymentUpload: any;
  submitted = false;
  form!: FormGroup;
  reviewDetails: FormGroup;
  userData: any;
  selectedReviewer: any;
  validEmail: any;
  placeOrderData: any;
  fileName: any = 'Selected File';
  base64File: string;
  order_reviewer: any;
  reviewOrderData: { serviceType: string; details: any };
  reviewer: any[] = [];
  paymentLink: any;
  option: any;
  paymentStatus: any;
  paymentAmount: any;
  isPaymentActive: boolean = true;
  apiResponse: any;
  signerLength: any;
  dscSerialNo: number;
  electronicSerialNo: number;
  addharSerialNo: number;
  eachSignCount: number;
  virtualAccountNo: string;
  is_wallet: boolean = false;
  gstOnStampFee: any;
  gstOnEsignFee: any;
  accountId: any;
  billingType: any;
  organisation_id: any;
  isLoading: boolean = true;
  stampProcessBy: string = '';
  razorpayHandlingCharge: any = 0;
  isPayableAmountZero: boolean = true;
  hidePayments: boolean = false;
  inventoryPayment: boolean = false;
  private popupWindow: Window | null = null;
  private confirmModalRef: NgbModalRef;
  private currentOption: any;
  cessPercentage: any = 0;

  readonly esignColumns: TableColumn[] = [
    { field: 'serial', header: 'Sr. No.' },
    { field: 'method', header: 'Method' },
    { field: 'price', header: 'Convenience Fee' },
    { field: 'qty', header: 'Quantity', cellClass: 'po-qty' },
    { field: 'amount', header: 'Amount' },
  ];

  get stampColumns(): TableColumn[] {
    return [
      { field: 'sr_no', header: 'Sr. No.' },
      { field: 'state_code', header: 'State Code', accessorFn: () => this.stateCode },
      {
        field: 'article_code',
        header: 'Article Code',
        accessorFn: (row) => this.getArticleCode(row.article_id),
        cellClass: 'po-article-code',
      },
      { field: 'stamp_duty', header: 'Stamp Duty' },
      { field: 'cess', header: `Cess ${this.cessPercentage * 100}%` },
      { field: 'convenience_fee', header: 'Convenience Fee' },
      { field: 'stamp_count', header: 'Quantity', fallback: '0', cellClass: 'po-qty' },
      { field: 'amount', header: 'Amount' },
    ];
  }

  get visibleStampDetails(): any[] {
    return (this.stampDetails || []).filter((stamp: any) => stamp.article_id !== '');
  }

  get esignRows(): {
    serial: number;
    methodLabel: string;
    methodClass: string;
    price: number;
    qty: number;
    amount: number;
  }[] {
    const rows = [];
    if (this.dscSigner.length !== 0) {
      rows.push({
        serial: this.dscSerialNo,
        methodLabel: 'DSC',
        methodClass: 'po-method-dsc',
        price: this.isWalletPostpaidWithStamps ? 0 : this.dscPrice,
        qty: this.dscSigner.length,
        amount: this.getCalculateValue(this.dscPrice, this.dscSigner.length),
      });
    }
    if (this.electronicSigner.length !== 0) {
      rows.push({
        serial: this.electronicSerialNo,
        methodLabel: 'ELECTRONIC',
        methodClass: 'po-method-electronic',
        price: this.isWalletPostpaidWithStamps ? 0 : this.electronicPrice,
        qty: this.electronicSigner.length,
        amount: this.getCalculateValue(this.electronicPrice, this.electronicSigner.length),
      });
    }
    if (this.aadhaarSigner.length !== 0) {
      rows.push({
        serial: this.addharSerialNo,
        methodLabel: 'AADHAAR',
        methodClass: 'po-method-aadhaar',
        price: this.isWalletPostpaidWithStamps ? 0 : this.aadhaarPrice,
        qty: this.aadhaarSigner.length,
        amount: this.getCalculateValue(this.aadhaarPrice, this.aadhaarSigner.length),
      });
    }
    if (this.cloudSigner.length !== 0) {
      rows.push({
        serial: this.cloudSerialNo,
        methodLabel: 'CLOUD SIGN',
        methodClass: 'po-method-cloud',
        price: this.isWalletPostpaidWithStamps ? 0 : this.cloudPrice,
        qty: this.cloudSigner.length,
        amount: this.getCalculateValue(this.cloudPrice, this.cloudSigner.length),
      });
    }
    return rows;
  }

  constructor(
    private preProcurementService: PreProcurementService,
    private catUploadService: CatUploadService,
    private messageService: MessageService,
    private router: Router,
    private catEditService: CatEditService,
    private eSignService: ESignService,
    private estampService: EstampService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    private orderService: OrderService,
    private walletService: WalletService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {
    this.order_reviewer = this.storageService.getOrderReviewConsent() || null;

    this.paymentData = new PaymentService();
    this.usedCurrency = this.paymentData.currencies[10].symbol;
    const isRazorpay = this.paymentOrderData.payment?.paymentMethod;
    this.form = this.formBuilder.group({
      name: new FormControl('', isRazorpay ? Validators.required : null),
      contact_number: new FormControl(
        '',
        isRazorpay
          ? [Validators.required, Validators.pattern('^[0-9]{10,10}$')]
          : null
      ),
      email: new FormControl('', isRazorpay ? Validators.required : null),
    });
    this.reviewDetails = this.formBuilder.group({
      reviewEmail: this.formBuilder.array([]),
      reviewer: [null],
    });
    this.virtualAccountNo = this.storageService.getVirtualAccountNumber();
    this.organisation_id = this.storageService.getOrganizationId() || null;
    this.is_wallet = this.storageService.getIsWallet();
    this.accountId = this.storageService.getAccountId();

    this.storageService.hidePaymentMethod$.subscribe((hidePayments) => {
      this.hidePayments = hidePayments;
    });

    this.storageService.inventoryPayment$.subscribe((inventoryPayment) => { 
      this.inventoryPayment = inventoryPayment;
    });
  }

  ngOnInit(): void {}

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  ngOnDestroy(): void {
    // console.log("component has destroyed")
    this.spinner.hide();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.spinner.show();
    this.stampDetails = [];
    this.signDetails = [];
    let organization_id = this.storageService.getOrganizationId() || null;
    let virtual_account_no =
      this.storageService.getVirtualAccountNumber() || null;

    const balance$ =
      this.is_wallet && virtual_account_no
        ? this.walletService.getWalletClientDetails(virtual_account_no)
        : this.orderService.getBalance(this.accountId);

    forkJoin({
      pricing: this.catUploadService.getPricingDetails(organization_id),
      balance: balance$,
    }).subscribe({
      next: ({ pricing, balance }) => {
        this.electronicPrice = pricing?.content?.esign?.electronic ?? 0;
        this.dscPrice        = pricing?.content?.esign?.dsc        ?? 0;
        this.aadhaarPrice    = pricing?.content?.esign?.aadhaar    ?? 0;
        this.cloudPrice      = pricing?.content?.esign?.cloud_sign ?? 0;
        this.stampPrice      = pricing?.content?.estamp            ?? 0;
        this.billingType     = pricing?.content?.billing           ?? '';

        if (balance?.status === 200) {
          this.walletBalance =
            balance?.content?.current_balance ??
            balance?.content?.balance ??
            0;
        }

        this.getTotalStampValue(this.stampDetails);
        this.getTotalEsignValue();
        this.getTotalAmount();
        this.spinner.hide();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (error) => {
        console.error('Payment order data fetch error:', error);
        this.spinner.hide();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });

    if (changes.paymentOrderData?.currentValue) {
      const data = changes.paymentOrderData.currentValue;
      if (data.orderDetails) {
        const Obj = data.orderDetails;
        this.paymentDetails = data.payment;
        const resolvedStateCode = data.stateCode || data.orderDetails?.selectedState?.state_code;
        if (resolvedStateCode) {
          this.stateCode = resolvedStateCode;
          this.getArticles(this.stateCode);
        }
        this.electronicSigner = [];
        this.aadhaarSigner = [];
        this.dscSigner = [];
        this.cloudSigner = [];
        if (Obj.order_details[0]?.estamps) {
          this.stampDetails = Obj.order_details[0]?.estamps.map((stamp: any) => ({
            ...stamp,
            stamp_count: stamp.stamp_count ?? 0,
            cessPer: stamp.cessPer ?? 0,
          }));
          this.stampProcessBy = this.stampDetails[0]?.process_type;
        }

        if (Obj.order_details[0]?.esigns?.party_users) {
          this.signDetails = Obj.order_details[0]?.esigns?.party_users;
          this.signDetails.forEach((element) => {
            if (element.method === 'ELECTRONIC') {
              this.electronicSigner.push(element);
            } else if (element.method === 'AADHAAR') {
              this.aadhaarSigner.push(element);
            } else if (element.method === 'DSC') {
              this.dscSigner.push(element);
            } else if (element.method === 'CLOUD_SIGN') {
              this.cloudSigner.push(element);
            }
          });
        }
        let currentSerialNo = 1;
        if (this.dscSigner.length !== 0) {
          this.dscSerialNo = currentSerialNo++;
        }
        if (this.electronicSigner.length !== 0) {
          this.electronicSerialNo = currentSerialNo++;
        }
        if (this.aadhaarSigner.length !== 0) {
          this.addharSerialNo = currentSerialNo++;
        }
        if (this.cloudSigner.length !== 0) {
          this.cloudSerialNo = currentSerialNo++;
        }

      } else {
        const orderDetails = data[0];
        if (orderDetails.esign[0]) {
          this.signDetails = orderDetails.esign;
          if (orderDetails.esign[0].method === 'ELECTRONIC') {
            this.electronicSigner.push(orderDetails.esign[0]);
          } else if (orderDetails.esign[0].method === 'AADHAAR') {
            this.aadhaarSigner.push(orderDetails.esign[0]);
          } else if (orderDetails.esign[0].method === 'DSC') {
            this.dscSigner.push(orderDetails.esign[0]);
          } else if (orderDetails.esign[0].method === 'CLOUD_SIGN') {
            this.cloudSigner.push(orderDetails.esign[0]);
          }
        }
      }
    } else if (changes.reOrderData?.currentValue) {
      const data = changes.reOrderData.currentValue;
      this.paymentDetails = data.payment_data;
    }
  }

  get isStampPreProcurement(): boolean {
    return this.stampProcessBy === 'PRE_PROCUREMENT';
  }

  get isWalletPrepaid(): boolean {
    return (
      this.paymentOrderData.payment?.paymentMethod === 'wallet' &&
      this.billingType === 'PREPAID'
    );
  }

  get isPrepaidWallet(): boolean {
    return this.isWallet && this.billingType === 'PREPAID';
  }

  get isRazorpayOrPrepaid(): boolean {
    return (
      this.paymentOrderData.payment?.paymentMethod === 'razorpay' ||
      this.paymentOrderData.payment?.paymentMethod === 'HDFC_GATEWAY' ||
      this.billingType === 'PREPAID'
    );
  }

  get isRazorpay(): boolean {
    return (this.paymentOrderData.payment?.paymentMethod === 'razorpay' 
      || this.paymentOrderData.payment?.paymentMethod === 'HDFC_GATEWAY'
    );
  }

  // get isHDFCPayment(): boolean {
  //   return this.paymentOrderData.payment?.paymentMethod === 'HDFC_GATEWAY';
  // }

  get isWallet(): boolean {
    return this.paymentOrderData.payment?.paymentMethod === 'wallet';
  }

  get isWalletPostpaidWithoutStamps(): boolean {
    return (
      this.paymentOrderData.payment?.paymentMethod === 'wallet' &&
      this.billingType === 'POSTPAID' &&
      this.stampDetails.length === 0
    );
  }

  get isWalletPostpaidWithStamps(): boolean {
    return (
      this.paymentOrderData.payment?.paymentMethod === 'wallet' &&
      this.billingType === 'POSTPAID' &&
      this.stampDetails.length > 0
    );
  }

  get isWalletPostpaidWithEsign(): boolean {
    return (
      this.paymentOrderData.payment?.paymentMethod === 'wallet' &&
      this.billingType === 'POSTPAID' &&
      this.signDetails.length > 0
    );
  }

  private updatePayableAmountStatus() {
    this.isPayableAmountZero = this.paymentAmount === 0;
  }

  getCalculateValue(quantity: number, price: number) {
    if (
      this.billingType === 'POSTPAID' &&
      this.paymentOrderData.payment?.paymentMethod === 'wallet'
    ) {
      return 0;
    }
    return quantity * price;
  }

  getTotalStampValue(data) {
    let totalValue = 0;
    let stamp_convenience_fees = 0;
    let stampPrice = this.inventoryPayment
      ? this.stampPrice
      : this.isStampPreProcurement
      ? 0
      : this.isWalletPostpaidWithStamps
      ? 0
      : this.stampPrice;

    data.forEach((stamp) => {
      if (stamp.article_id && stamp.article_id !== '') {
        const stampCount = stamp.stamp_count || 0;
        const cessPer = stamp.cessPer || 0;
        totalValue +=
          (this.inventoryPayment ? stamp.stamp_duty_amount : this.isStampPreProcurement ? 0 : stamp.stamp_duty_amount) +
          (stampPrice * stampCount) +
          (this.inventoryPayment ? (stamp.stamp_duty_amount * cessPer) : this.isStampPreProcurement
            ? 0 : (stamp.stamp_duty_amount * cessPer));
        stamp_convenience_fees += (stampPrice * stampCount);
      }
    });

    this.gstOnStampFee = parseFloat((stamp_convenience_fees * 0.18).toFixed(2));
    this.stampAmountTotal = totalValue;
    return totalValue;
  }

  getTotalEsignValue() {
    let totalSignValue =
      this.getCalculateValue(this.dscPrice, this.dscSigner.length) +
      this.getCalculateValue(this.aadhaarPrice, this.aadhaarSigner.length) +
      this.getCalculateValue(this.electronicPrice, this.electronicSigner.length) +
      this.getCalculateValue(this.cloudPrice, this.cloudSigner.length); 

    let esign_convenience_fees = totalSignValue;
    this.gstOnEsignFee = parseFloat((esign_convenience_fees * 0.18).toFixed(2));
    this.signAmountTotal = totalSignValue;
    return totalSignValue;
  }

  numberOnly(event: any) {
    const pattern = /[0-9\-]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  getArticles(id) {
    let queryParams = { state_code: id };
    this.preProcurementService.getArticles(queryParams).subscribe((resp) => {
      if (resp.status) {
        this.articles = resp['content'];
        if (this.stampDetails && this.stampDetails.length > 0) {
          this.fetchStampCount();
        }
      }
    });
  }

  fetchStampCount() {
    if (!this.stampDetails || this.stampDetails.length === 0) {
      return;
    }

    // Build the estamps array for the API request
    this.stampDetails = this.stampDetails
      .filter((stamp) =>
        stamp.article_id &&
        stamp.article_id !== "N/A"
      )

    // Build the estamps array for the API request
    const estampsForRequest = this.stampDetails.map((stamp) => ({
      article_code: this.getArticleCode(stamp.article_id),
      state_code: this.stateCode,
      stamp_duty_amount: stamp.stamp_duty_amount,
    }));

    // Prepare the request payload
    const requestPayload = {
      account_id: this.accountId,
      order_type: this.isStampPreProcurement ? 'inventory' : 'on_the_fly',
      estamps: estampsForRequest,
    };

    // Call the API to get required stamp count
    this.estampService.getOrderRequiredStampCount(requestPayload).subscribe({
      next: (response) => {
        if (response.status === 200 && response.content?.required_stamp_count?.estamps) {
          const apiEstamps = response.content.required_stamp_count.estamps;
          this.insufficientInventory = false;
          this.stampDetails.forEach((stamp, idx) => {
            stamp.stamp_count = apiEstamps[idx]?.stamp_count || 0;
            stamp.cessPer = apiEstamps[idx]?.cess || 0;
            this.cessPercentage = apiEstamps[idx]?.cess || 0;
            if (stamp.stamp_count === 0) {
              this.insufficientInventory = true;
            }
          });
          this.getTotalStampValue(this.stampDetails);
          this.getTotalAmount();
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        this.stampDetails.forEach((stamp) => {
          if (!stamp.stamp_count) {
            stamp.stamp_count = 0;
          }
          if (!stamp.cessPer) {
            stamp.cessPer = 0;
          }
        });
        this.insufficientInventory = true;
        this.getTotalStampValue(this.stampDetails);
        this.getTotalAmount();
        this.cdr.detectChanges();
      },
    });
  }

  getArticleCode(id: number) {
    const article = this.articles.find((element) => element.id === id);
    return article ? article.article_code : 'N/A';
  }

  getTotalAmount() {
    if (this.isWalletPrepaid || this.isRazorpay) {
      let total =
        this.stampAmountTotal +
        this.signAmountTotal +
        this.gstOnEsignFee +
        this.gstOnStampFee;

      if (this.isRazorpay) {
        let razorpayHandlingCharges = total * 0.03; 
        this.razorpayHandlingCharge =
          Math.round(razorpayHandlingCharges * 100) / 100;
        total += this.razorpayHandlingCharge;
      }
      this.paymentAmount = Math.round(total * 100) / 100;
      this.updatePayableAmountStatus();
      if (this.walletBalance >= this.paymentAmount) {
        this.canWalletPayment = true;
      } else {
        this.canWalletPayment = false;
      }
    } else {
      if (this.isWalletPostpaidWithStamps) {
        let total = this.stampAmountTotal;
        if (this.isRazorpay) {
          let razorpayHandlingCharges = total * 0.03; 
          this.razorpayHandlingCharge =
            Math.round(razorpayHandlingCharges * 100) / 100;
          total += this.razorpayHandlingCharge;
        }
        this.paymentAmount = Math.round(total * 100) / 100;
        this.updatePayableAmountStatus();
        if (this.walletBalance >= this.paymentAmount) {
          this.canWalletPayment = true;
        } else {
          this.canWalletPayment = false;
        }
      } else {
        this.paymentAmount = 0;
        this.updatePayableAmountStatus();
        if (this.walletBalance >= this.paymentAmount) {
          this.canWalletPayment = true;
        } else {
          this.canWalletPayment = false;
        }
      }
    }
    return this.paymentAmount;
  }

  payBill() {
    if (this.form.valid) {
      this.submitted = true;
      if (this.order_reviewer) {
        this.confirmOrder('payLate');
      } else if (!this.order_reviewer) {
        this.placeOrderBulk('payLate');
      }
    } else {
      return;
    }
  }

  payBillNow() {
    if (!this.form.valid || (this.isWallet && !this.canWalletPayment)) {
      return;
    }
    if (this.form.valid) {
      this.submitted = true;
      this.storageService.setProcessType('');
      this.storageService.setHidePaymentMethod(false);
      this.placeOrderBulk('payNow');
    } else {
      console.log('return from pay bill now');
      return;
    }
  }
  confirmOrder(option) {
    this.currentOption = option; // Store the option
    this.confirmModalRef = this.modalService.open(this.confirmOrderModal, {
      centered: true,
      backdrop: 'static',
    });
  }

  onAcceptConfirm() {
    this.placeOrderBulk(this.currentOption);
    this.closeConfirmModal();
  }

  onRejectConfirm() {
    this.onApproveMethod();
    this.closeConfirmModal();
  }

  closeConfirmModal() {
    if (this.confirmModalRef) {
      this.confirmModalRef.close();
    }
  }
  placeOrderBulk(option) {
    if (this.insufficientInventory) {
      this.messageService.add({
        severity: 'error',
        summary: 'Insufficient Inventory',
        detail: 'Insufficient inventory. Please check your stamp inventory.',
      });
      return;
    }
    this.option = option;
    const orderIdFromUrl = this.route.snapshot.queryParamMap.get('order_id');
    const orderDetails = this.paymentOrderData.orderDetails.order_details;
    const paymentMethod = this.paymentOrderData.payment?.paymentMethod;
    const selectedProvider = this.storageService.getSelectedProvider();
    const finalProvider = selectedProvider === 'HDFC_GATEWAY' ? 'RAZORPAY_HDFC_GATEWAY' : selectedProvider;
    const reviewData = {
      serviceType: this.paymentOrderData.service_type,
      details: orderDetails,
    };
    this.reviewOrderData = reviewData;
    let eSignBill = [];
    this.signDetails.forEach((element) => {
      if (element.method === 'ELECTRONIC') {
        eSignBill.push({
          sign_method: element.method,
          price: this.isRazorpayOrPrepaid ? this.electronicPrice : 0,
          amount: this.isRazorpayOrPrepaid ? this.electronicPrice : 0,
          quantity: 1,
        });
      } else if (element.method === 'AADHAAR') {
        eSignBill.push({
          sign_method: element.method,
          price: this.isRazorpayOrPrepaid ? this.aadhaarPrice : 0,
          amount: this.isRazorpayOrPrepaid ? this.aadhaarPrice : 0,
          quantity: 1,
        });
      } else if (element.method === 'DSC') {
        eSignBill.push({
          sign_method: element.method,
          price: this.isRazorpayOrPrepaid ? this.dscPrice : 0,
          amount: this.isRazorpayOrPrepaid ? this.dscPrice : 0,
          quantity: 1,
        });
      } else if (element.method === 'CLOUD_SIGN') { 
        eSignBill.push({
          sign_method: element.method,
          price: this.isRazorpayOrPrepaid ? this.cloudPrice : 0,
          amount: this.isRazorpayOrPrepaid ? this.cloudPrice : 0,
          quantity: 1,
        });
      }
    });
    let eStampBill = [];

    this.stampDetails.forEach((element) => {
      let stamp_duty_amount = 
        this.inventoryPayment ? 
        element.stamp_duty_amount 
        : this.isStampPreProcurement
        ? 0
        : element.stamp_duty_amount;
      let stamp_price = 
        this.inventoryPayment ? this.stampPrice :
        this.isStampPreProcurement
        ? 0
        : this.isRazorpayOrPrepaid
        ? this.stampPrice
        : 0;
      eStampBill.push({
        article_code: this.getArticleCode(element.article_id),
        state_code: this.stateCode,
        stamp_amount: stamp_duty_amount,
        price: stamp_price,
        amount: stamp_duty_amount + stamp_price,
        quantity: 1,
      });
    });
    if (this.isWallet && !this.isPayableAmountZero) {
      orderDetails[0].wallet_data = {
        amount: this.getTotalAmount(),
        stamp_rate: orderDetails[0].estamps ? this.stampPrice : 0,
        esign_rate: {
          electronic:
            orderDetails[0].esigns?.party_users[0]?.method === 'ELECTRONIC'
              ? this.electronicPrice
              : 0,
          dsc:
            orderDetails[0].esigns?.party_users[0]?.method === 'DSC'
              ? this.dscPrice
              : 0,
          aadhaar:
            orderDetails[0].esigns?.party_users[0]?.method === 'AADHAAR'
              ? this.aadhaarPrice
              : 0,
          cloud: 
            orderDetails[0].esigns?.party_users[0]?.method === 'CLOUD_SIGN' 
              ? this.cloudPrice 
              : 0
        },
        stamp_bill: eStampBill,
        esign_bill: eSignBill,
        billing: this.billingType,
      };
    } else if (paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') {
      orderDetails[0].payment_data = {
        payee_email: this.paymentOrderData.payment?.payeeEmail,
        payee_name: this.paymentOrderData.payment?.payeeName,
        payee_contact: this.paymentOrderData.payment?.payeeMobileNumber,
        description: 'Test Payment Order',
        amount: this.getTotalAmount(),
        stamp_rate: orderDetails[0].estamps ? this.stampPrice : 0,
        esign_rate: {
          electronic:
            orderDetails[0].esigns?.party_users[0]?.method === 'ELECTRONIC'
              ? this.electronicPrice
              : 0,
          dsc:
            orderDetails[0].esigns?.party_users[0]?.method === 'DSC'
              ? this.dscPrice
              : 0,
          aadhaar:
            orderDetails[0].esigns?.party_users[0]?.method === 'AADHAAR'
              ? this.aadhaarPrice
              : 0,
          cloud: 
            orderDetails[0].esigns?.party_users[0]?.method === 'CLOUD_SIGN'
              ? this.cloudPrice
              : 0,
        },
        stamp_bill: eStampBill,
        esign_bill: eSignBill,
        handling_charge: this.razorpayHandlingCharge,
        payment_provider: finalProvider || "RAZORPAY_GATEWAY"
      };
    }
    orderDetails[0].signatory_details = this.signDetails;
    if (this.reviewer && this.reviewer.length > 0) {
      orderDetails[0].order_reviewers = this.reviewer;
    }
    this.catPaymentUpload = {
      ...(orderIdFromUrl && { order_id: orderIdFromUrl }),
      is_draft: false,
      document: this.paymentOrderData.orderDetails.document,
      file_name: this.paymentOrderData.orderDetails.file_name,
      is_bulk: this.paymentOrderData.orderDetails.is_bulk,
      multi_document: this.paymentOrderData.orderDetails.multi_document,
      order_details: orderDetails,
      template_id: this.paymentOrderData.orderDetails.template_id,
    };
    this.paymentOrderDetails.emit(this.catPaymentUpload);
    if (this.isWallet && !this.isPayableAmountZero) {
      this.paymentOrderData.orderDetails.order_details[0].wallet_data = {
        amount: this.getTotalAmount(),
        stamp_rate: this.paymentOrderData.orderDetails.order_details[0].estamps
          ? this.stampPrice
          : 0,
        esign_rate: {
          electronic:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'ELECTRONIC'
              ? this.electronicPrice
              : 0,
          dsc:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'DSC'
              ? this.dscPrice
              : 0,
          aadhaar:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'AADHAAR'
              ? this.aadhaarPrice
              : 0,
          cloud: 
            this.paymentOrderData.orderDetails.order_details[0].esigns
             ?.party_users[0]?.method === 'CLOUD_SIGN' 
             ? this.cloudPrice 
             : 0
        },
        stamp_bill: eStampBill,
        esign_bill: eSignBill,
        billing: this.billingType,
      };
      this.paymentOrderData.orderDetails.order_details[0].wallet_data.virtual_account_no =
        this.virtualAccountNo;
    } else if (paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') {
      this.paymentOrderData.orderDetails.order_details[0].payment_data = {
        payee_email: this.paymentOrderData.payment?.payeeEmail,
        payee_name: this.paymentOrderData.payment?.payeeName,
        payee_contact: this.paymentOrderData.payment?.payeeMobileNumber,
        description: 'Test Payment Order',
        amount: this.getTotalAmount(),
        stamp_rate: this.paymentOrderData.orderDetails.order_details[0].estamps
          ? this.stampPrice
          : 0,
        esign_rate: {
          electronic:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'ELECTRONIC'
              ? this.electronicPrice
              : 0,
          dsc:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'DSC'
              ? this.dscPrice
              : 0,
          aadhaar:
            this.paymentOrderData.orderDetails.order_details[0].esigns
              ?.party_users[0]?.method === 'AADHAAR'
              ? this.aadhaarPrice
              : 0,
          cloud: 
            this.paymentOrderData.orderDetails.order_details[0].esigns
             ?.party_users[0]?.method === 'CLOUD_SIGN' 
             ? this.cloudPrice 
             : 0
        },
        stamp_bill: eStampBill,
        esign_bill: eSignBill,
        handling_charge: this.razorpayHandlingCharge,
        payment_provider: finalProvider || "RAZORPAY_GATEWAY"
      };
    }
    let totalAmount = this.getTotalAmount(); 
    console.log(totalAmount);
    if (this.isWallet && !this.isPayableAmountZero) {
      this.paymentOrderData.orderDetails.order_details[0].wallet_data.amount =
        this.getTotalAmount();
    } else if (paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') {
      this.paymentOrderData.orderDetails.order_details[0].payment_data.amount =
        this.getTotalAmount();
    }
    this.paymentOrderData.orderDetails.order_details[0].signatory_details =
      this.signDetails;
    if (this.paymentOrderData.service_type === 'Cat Upload') {
      this.catUploadService
        .catUploadPlaceOrder(this.catPaymentUpload, orderIdFromUrl)
        .subscribe((res: any) => {
         this.handleResponse(res, paymentMethod, option, orderIdFromUrl);
        });
    }
    if (this.paymentOrderData.service_type === 'E-Stamp') {
      this.estampService
        .postEstampData(this.catPaymentUpload)
        .subscribe((res: any) => {
          if ((paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') && option !== 'payLate') {
            this.showPaymentModal(res);
          } else {
            if (res.status === 200) {
              this.messageService.add({
                severity: 'success',
                detail: res.message,
              });
              this.router.navigate([
                'doqfy/e-stamp/order-confirmation',
                res.content.order_id,
              ]);
              setTimeout(() => {
                this.paymentOrderDataChange.next(res);
              }, 1000);
            } else {
              this.messageService.add({
                severity: 'warning',
                summary: 'SignIng',
                detail: res.message,
              });
            }
          }
        });
    } else if (this.paymentOrderData.service_type === 'E-Sign') {
      this.eSignService
        .sendEsignDetails(this.catPaymentUpload)
        .subscribe((res: any) => {
          if ((paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') && option !== 'payLate') {
            this.showPaymentModal(res);
          } else {
            if (res.status === 200) {
              this.messageService.add({
                severity: 'success',
                detail: res.message,
              });
              this.router.navigate([
                'doqfy/e-sign/order-confirmation/',
                res.content.order_id,
              ]);
              setTimeout(() => {
                this.paymentOrderDataChange.next(res);
              }, 1000);
            } else {
              this.messageService.add({
                severity: 'warning',
                summary: 'SignIng',
                detail: res.message,
              });
            }
          }
        });
    } else if (this.paymentOrderData.service_type === 'Cat-Edit' || this.paymentOrderData.service_type === 'CAT-Compose' || this.paymentOrderData.service_type === 'Cat-Compose') {
      this.catEditService
        .postOrder(this.catPaymentUpload)
        .subscribe((res: any) => {
          if ((paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') && option !== 'payLate') {
            this.showPaymentModal(res);
          } else {
            if (res.status === 200) {
              this.messageService.add({
                severity: 'success',
                detail: res.message,
              });
              const confirmationRoute =
                this.paymentOrderData.service_type === 'Cat-Compose' ||
                this.paymentOrderData.service_type === 'CAT-Compose'
                  ? 'doqfy/cat-compose/order-confirmation'
                  : 'doqfy/cat-edit/order-confirmation';
              this.router.navigate([confirmationRoute, res.content.order_id]);
              setTimeout(() => {
                this.paymentOrderDataChange.next(res);
              }, 1000);
            } else {
              this.messageService.add({
                severity: 'warning',
                summary: 'SignIng',
                detail: res.message,
              });
            }
          }
        });
    } else {
    }
  }

 handleResponse(res: any, paymentMethod: string, option: string, orderIdFromUrl: string | null) {
  if ((paymentMethod === 'razorpay' || paymentMethod === 'HDFC_GATEWAY') && option !== 'payLate') {
    this.showPaymentModal(res);
    return; 
  }

  if (res.status === 200) {
    this.messageService.add({
      severity: 'success',
      detail: orderIdFromUrl ? 'Order updated and placed successfully' : res.message,
    });

    // Navigate to confirmation page
    this.router.navigate([
      'doqfy/cat-edit/order-confirmation',
      res.content.order_id,
    ]);

    setTimeout(() => {
      this.paymentOrderDataChange.next(res);
    }, 1000);

  } else {
    this.messageService.add({
      severity: 'warning',
      summary: 'Issue',
      detail: res.message,
    });
  }
}

  showPaymentModal(data) {
    this.paymentLink = data.content.payment_link;
    this.popupWindow = window.open(this.paymentLink, '_blank');
    this.storageService.setPaymentStatus('payment_started');
    this.startPaymentInterval();

    const checkWindowInterval = setInterval(() => {
      if (this.popupWindow && this.popupWindow.closed) {
        this.onPopupClosed(data);
        clearInterval(checkWindowInterval);
      }
    }, 1000);
  }

  onPopupClosed(data) {
    this.modalService.dismissAll();

    this.router.navigate(['/doqfy/orders/orders-list'], {
      queryParams: {
        id: data.content.order_id,
      },
    });
  }

  startPaymentInterval() {
    this.modalService
      .open(this.paymentModal, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
    this.paymentStatus = setInterval(() => {
      let paymentState = this.storageService.getPaymentStatus() || null;
      if (paymentState === 'payment_started') {
      } else if (paymentState === 'payment_successfull') {
        this.redirectToOrderConfirmation();
        this.closeModel();
      } else if (paymentState === 'payment_failed') {
        this.redirectToOrderConfirmation();
        this.closeModel();
      }
    }, 2000); //
  }

  redirectToOrderConfirmation() {
    let order_id = this.storageService.getOrderId() || null;
    clearInterval(this.paymentStatus);
    if (order_id) {
      if (this.paymentOrderData.service_type === 'Cat-Edit') {
        this.router.navigate(['doqfy/cat-edit/order-confirmation', order_id]);
      } else if (this.paymentOrderData.service_type === 'E-Stamp') {
        this.router.navigate(['doqfy/e-stamp/order-confirmation', order_id]);
      } else if (this.paymentOrderData.service_type === 'E-Sign') {
        this.router.navigate(['doqfy/e-sign/order-confirmation/', order_id]);
      } else if (this.paymentOrderData.service_type === 'Cat Upload') {
        this.router.navigate([
          'doqfy/cat-execution/order-confirmation',
          order_id,
        ]);
      } else if (
        this.paymentOrderData.service_type === 'Cat-Compose' ||
        this.paymentOrderData.service_type === 'CAT-Compose'
      ) {
        this.router.navigate(['doqfy/cat-compose/order-confirmation', order_id]);
      }
    }
  }
  onApproveMethod() {
    const orderDetails = this.paymentOrderData;
    const reviewData = {
      serviceType: this.paymentOrderData.service_type,
      details: orderDetails,
    };
    this.reviewOrderData = reviewData;
    this.modalService
      .open(this.reviewOrder, {
        // Use this.reviewOrder directly
        size: 'xl',
        ariaLabelledBy: 'modal-basic-title',
        backdrop: 'static',
        keyboard: false,
      })
      .result.then(
        (result) => {
          console.log(result);
        },
        (reason) => {
          console.log(reason);
        }
      );
  }
  // reviewOrderDataChange(data: any) {
  //   this.closeModel();
  //   if (data.path === 'order') {
  //     this.placeOrderData(data.details)
  //   }
  // }
  addingReviewer(data) {
    if (data.isPlaceOrder) {
      data.reviewer.forEach((element) => {
        this.reviewer.push(element.email);
      });
      this.placeOrderBulk('payLate');
      this.closeModel();
    } else {
      this.closeModel();
    }
  }
  closeModel() {
    this.modalService.dismissAll();
  }

  getBalance(id) {
    this.orderService.getBalance(id).subscribe((resp) => {
      if (resp.status == 200) {
        this.walletBalance = resp.content.balance;
        console.log(resp.content.balance);
        console.log(this.walletBalance);
      }
    });
  }
}